import React from 'react'
import Button from "../Button";
import {type EntityType, type SelectedItem, type SelectedItemsData} from "../EntitySelector/EntitySelector.types";
import {SelectedItems} from "../EntitySelectorModal/SelectedItems";

// Types ----

type SelectedItemsWrapperProps = {
  selectedItems: SelectedItemsData
  selectedItemCount: number
  onRemoveItem: <K extends EntityType>(item: SelectedItem<K>, entityType: K) => void
  onClearItems?: () => void
  isMultiSite?: boolean
}

// Component ----

function SelectedItemsWrapper({ selectedItems, selectedItemCount, onRemoveItem, onClearItems, isMultiSite }: SelectedItemsWrapperProps) {
  function handleClearItems() {
    onClearItems?.();
  }

  return (
    <div className='rounded-md border border-gray-200 bg-white'>
      <div className='flex items-center gap-x-2.5 justify-between px-3 py-2 border-b border-b-gray-200'>
        <h4 className='text-gray-600 text-sm'>Selected • {selectedItemCount}</h4>
        <Button
          color={Button.colors.WHITE}
          size={Button.sizes.TINY}
          onClick={handleClearItems}
          disabled={!selectedItemCount}
        >
          Clear all
        </Button>
      </div>

      {selectedItemCount > 0 ?
        <div className='flex flex-col gap-5 max-h-80 overflow-y-auto relative pb-3 px-3'>
          <SelectedItems selectedItems={selectedItems} onRemoveItem={onRemoveItem} isMultiSite={isMultiSite} />
        </div> :
        <p className='py-5 px-4 text-center text-gray-500 text-sm'>Nothing selected</p>
      }
    </div>
  );
}

export {SelectedItemsWrapper};